import ReducersFactory from '../../lib/reducers/ReducersFactory';

const questionsMappings = new ReducersFactory('questionsMappings', [])


export default questionsMappings.reducer